import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  inject,
  input,
  InputSignal,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {UserStateService} from '@services/frontend/user-state.service';

@Component({
  selector: 'app-header-user',
  imports: [RouterLink],
  templateUrl: './header-user.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderUser implements OnInit {
  private readonly router = inject(Router);
  private readonly userStateService = inject(UserStateService);
  private readonly host = inject(ElementRef<HTMLElement>);

  fullName: InputSignal<string> = input.required<string>();
  email: InputSignal<string> = input.required<string>();
  isAdmin: InputSignal<boolean> = input<boolean>(false);
  settingsUrl: InputSignal<string> = input<string>('');

  menuOpen: WritableSignal<boolean> = signal(false);
  initial: string = '';

  ngOnInit() {
    const userNameParts = this.fullName().split(' ');
    if (userNameParts.length >= 2) {
      this.initial = userNameParts[0].charAt(0) + userNameParts[1].charAt(0);
    } else if (userNameParts.length === 1) {
      this.initial = userNameParts[0].charAt(0);
    }
  }

  toggleMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.menuOpen.update((v) => !v);
  }

  closeMenu(): void {
    this.menuOpen.set(false);
  }

  logout(): void {
    this.closeMenu();
    this.userStateService.deleteToken();
    void this.router.navigate(['/login']);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.host.nativeElement.contains(event.target as Node)) {
      this.menuOpen.set(false);
    }
  }
}
